module.exports = __webpack_public_path__ + "img/hemline sweep.50fe025d.png";